import React from 'react';
import UnavailableBanner from './UnavailableBanner';
import { Grid, Box } from '@mui/material';

class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    componentDidCatch(error, info) {
      // Display fallback UI
      this.setState({ hasError: true });
      // You can also log the error to an error reporting service
    //   logErrorToMyService(error, info);
    }
  
    render() {
      if (this.state.hasError) {
        // You can render any custom fallback UI
        return (
          <Grid
            container
            spacing={0}
            direction="column"
            justifyContent="center"
            alignItems="inherit"
            sx={{
              flexGrow: 1,
              maxWidth: '100%',
              marginBottom: '525px',
            }}
          >
            <Box
              sx={{
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top center',
                backgroundSize: 'cover',
                float: 'left',
                width: '100%',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  width: '100%',
                  background: 'transparent',
                  justifyContent: 'flex-start',
                  flexWrap: 'wrap',
                }}
              >
                <UnavailableBanner />
              </Box>
            </Box>
          </Grid>  
        );
      }
     return this.props.children;
    }
  }

  export default ErrorBoundary;